// extracted by mini-css-extract-plugin
module.exports = {"FirstLink":"TextGroupSectionA_FirstLink__laYti","Logo":"TextGroupSectionA_Logo__3pxyE"};